import React, { useEffect, useState } from 'react';
import Loader from '@tcl-boron-prefabs/loader';
import { useHistory } from 'react-router-dom';
import cn from 'classnames';
import typography from '@tcl-boron-styles/typography/dist/index.module.css';
import qs from 'query-string';
import styles from '../../styles';
import withStyles from '@tempus/component-library/utils/withStyles';
import { sanitizeQueryObj, updateSubsription } from '../../utils/subscriptions';

const SUBSCRIPTION_STATUS = {
  SUBSCRIBED: 'SUBSCRIBED',
  UNSUBSCRIBED: 'UNSUBSCRIBED',
};

const Subscriptions = ({ classes }) => {
  const history = useHistory();
  const [submissionState, setSubmissionState] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [submittedQuery, setSubmittedQuery] = useState(undefined);

  useEffect(() => {
    async function init() {
      const queryObj = sanitizeQueryObj(qs.parse(window.location.search));
      if (queryObj?.token) {
        setSubmittedQuery(queryObj);
        window.history.replaceState(null, '', window?.location?.pathname.replace(/\?token=\/\w+/gm, ''));
        updateSubscription(queryObj);
      }
    }
    init();
  }, [history]);

  async function updateSubscription(queryObj) {
    setSubmitting(true);
    if (queryObj) {
      try {
        const res = await updateSubsription(queryObj);
        setSubmissionState(res.enabled ? SUBSCRIPTION_STATUS.UNSUBSCRIBED : SUBSCRIPTION_STATUS.SUBSCRIBED);
      } catch (err) {
        setSubmissionState(null);
      }
      setSubmitting(false);
    }
  }

  function render() {
    if (submissionState === SUBSCRIPTION_STATUS.UNSUBSCRIBED) {
      return (
        <>
          <h1 className={cn(typography.H1)} data-testid="unsubscribed-header">
            You've unsubscribed
          </h1>
          <p className={cn(typography.Paragraph)} data-testid="unsubscribed-paragraph">
            You will no longer receive emails from Tempus to your inbox.
          </p>
          <p className={cn(typography.Paragraph)}>Unsubscribed by accident?</p>
          <p className={cn(typography.Paragraph)}>
            <span
              className={cn(typography.link)}
              onClick={(e) => {
                e.stopPropagation();
                updateSubscription({ ...submittedQuery, enabled: false });
              }}
            >
              Subscribe again
            </span>
          </p>
        </>
      );
    } else if (submissionState === SUBSCRIPTION_STATUS.SUBSCRIBED) {
      return (
        <>
          <h1 className={cn(typography.H1)} data-testid="resubscribed-header">
            You are subscribed
          </h1>
          <p className={cn(typography.Paragraph)} data-testid="resubscribed-paragraph">
            You will continue to receive emails from Tempus to your inbox.
          </p>
        </>
      );
    } else {
      return (
        <>
          <h1 className={cn(typography.H1)} data-testid="submitted-header">
            Something went wrong
          </h1>
          <p className={cn(typography.Paragraph)} data-testid="submitted-paragraph">
            We’re sorry, but we weren’t able to change your subscription preference.
          </p>
          <p className={cn(typography.Paragraph)}>
            Contact{' '}
            <a className={cn(typography.link)} href="mailto:support@tempus.com">
              support@tempus.com{' '}
            </a>{' '}
            or call 800-739-4137 for assistance.
          </p>
        </>
      );
    }
  }

  return (
    <div className="app-view-container trouble-logging-in-message" data-testid="subscription-form">
      {submitting ? (
        <div className={cn('app-view-container', classes.loadingContainer)}>
          <Loader />
        </div>
      ) : (
        render()
      )}
    </div>
  );
};

export default withStyles(styles)(Subscriptions);
